import React from "react";
import PropTypes from "prop-types";

export const ArticleField = ({ field, html }) => {
  // eslint-disable-next-line react/no-danger, react/no-multi-comp
  const HtmlContent = ({ html }) => <div dangerouslySetInnerHTML={{__html:html}} />;

  if (!html) {
    return null;
  }

  return (
    <React.Fragment>
      <dt>{field}</dt>
      <dd>
        <HtmlContent html={html} />
      </dd>
    </React.Fragment>
  );
};

ArticleField.propTypes = {
  field: PropTypes.node,
  html: PropTypes.string
};
